export default "__VITE_ASSET___x2YVzeP__";